import { NeuroFaixaEtariaEnum, StatusAvaliadoEnum } from 'graphql/types.generated'

import { AvaliacaoDesenvolvimentoModel } from '../model'

export const alcancadoComAtivo = (it: AvaliacaoDesenvolvimentoModel) =>
  (it?.statusButton === StatusAvaliadoEnum.PRESENTE || it?.statusButton === StatusAvaliadoEnum.PRESENTE_COM_ATRASO) &&
  it?.faixaEtariaEnum !== NeuroFaixaEtariaEnum.PRIMEIROS_15_DIAS
